<template>
<div>
  <div>
    <div id="carrousel">
      <b-carousel v-if="imgCarrousel.length>1"
        id="carouselClient"
        v-bind:interval="confCarrousel.vitesse*1000"
        fade
        indicators
        img-width="1024"
        img-height="480"
      >
        <div v-for="item in imgCarrousel" :key="item.chemin_img">
          <b-carousel-slide
            v-bind:img-src="'/api/imgCarrousel/'+item.chemin_img"
          ></b-carousel-slide>
        </div>
      </b-carousel>
      <b-carousel v-else-if="imgCarrousel.length>0"
        id="carouselClient"
        img-width="1024"
        img-height="480"
      >
        <div v-for="item in imgCarrousel" :key="item.chemin_img">
          <b-carousel-slide
            v-bind:img-src="'/api/imgCarrousel/'+item.chemin_img"
          ></b-carousel-slide>
         </div>
      </b-carousel>
      <b-carousel v-else>
      </b-carousel>
    </div>
    <h1 style='text-align:center;margin-top: 2em;'>Bienvenue {{$store.state.info.prenom||""}} {{$store.state.info.nom||""}}</h1>
    <h4 style='text-align:center;'>Vous êtes connecté sur le site de {{$store.state.info.socname}}</h4>
    <h4 style='text-align:center;'>Vous trouverez ici tous vos documents à télécharger ainsi que vos informations personnelles.</h4>
    <div class="homeCard">
      <div v-on:click="redirectDocuments">
        <el-card v-on:click="redirectDocuments" :body-style="{ padding: '0px'}">
          <i style="font-size:32px;width:100%;text-align: center;padding-top: 10px;" class="fas fa-archive"></i>
          <div style="padding: 14px;text-align: center;">
            <span>Mes Documents</span>
          </div>
        </el-card>
      </div>
      <div v-on:click="redirectEcommerce">
        <el-card :body-style="{ padding: '0px'}">
          <i style="font-size:32px;width:100%;text-align: center;padding-top: 10px;" class="fas fa-dollar-sign"></i>
          <div style="padding: 14px;text-align: center;">
            <span>E-Commerce</span>
          </div>
        </el-card>
      </div>
      <div v-on:click="redirectSupport">
        <el-card v-on:click="redirectDocuments" :body-style="{ padding: '0px'}">
          <i style="font-size:32px;width:100%;text-align: center;padding-top: 10px;" class="fas fa-ticket-alt"></i>
          <div style="padding: 14px;text-align: center;">
            <span>Mes tickets</span>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <div v-if="post.logo" class="logoEntreprise" style="margin-top:5em;">
      <img :src="'/api/logoClient?v='+post.id" alt=""/>
    </div> -->
  </div>
</div>
</template>

<script>
import script from '../../../script/script.js';

export default {
  data() {
    return {
      post: {},
      imgCarrousel:[],
      confCarrousel:{
        vitesse:''
      }
    }
  },
  mounted:function(){
    this.verifyRight();
    this.loadingInfo();
    this.loadCarrousel();
    this.loadSpeed();
  },
  methods: {
    verifyRight: script.verifyRight,
    loadCarrousel: script.loadCarrousel,
    loadSpeed: script.loadSpeed,
    loadingInfo: script.loadingInfo,
    redirectDocuments(){
      this.$router.push({ path: '/mesDocuments' })
    },
    redirectEcommerce(){
      this.$router.push({ path: '/e-commerce' })
    },
    redirectSupport(){
      this.$router.push({ path: '/assistance' })
    },
  }
  
}
</script>

<style>
#carrousel{
  width:30%;
  margin:auto;
}

.logoEntreprise{
  text-align: center;
}

.logoEntreprise > img{
  width: 20%;
}

.homeCard{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-evenly;
}
</style>
